<template>
	<div class="mg-b-20 mg-lg-b-25 mg-xl-b-30">
		<div class="row justify-content-center">
			<div class="col-md-6 mb-5">
				<alert-success :form="form" :class="'shadow-sm'" message="Your password has been changed!"></alert-success>

				<h3 class="tx-color-01">Change Password</h3>
				<p class="tx-color-03 mg-b-30">After clicking on “Change Password”, you will receive an SMS code to activate your new password.</p>

				<form method="POST" action="/api/user/change-password" @submit.prevent="changePassword">
					<div class="form-group">
						<label>Current Password</label>
						<input v-model="form.current_password" type="password" class="form-control shadow-sm" :class="{ 'is-invalid': form.errors.has('current_password') }" name="current_password" placeholder="Enter your current password" required>
						<has-error :form="form" field="current_password"></has-error>
					</div>
					<div class="form-group">
						<label>Password</label>
						<input v-model="form.password" type="password" class="form-control shadow-sm" :class="{ 'is-invalid': form.errors.has('password') }" name="password" placeholder="Enter a new password" required>
						<has-error :form="form" field="password"></has-error>
					</div>
					<div class="form-group">
						<label>Confirm Password</label>
						<input v-model="form.password_confirmation " type="password" class="form-control shadow-sm" :class="{ 'is-invalid': form.errors.has('password_confirmation ') }" name="password_confirmation " placeholder="Enter password again" required>
						<has-error :form="form" field="password_confirmation "></has-error>
					</div>
					<div class="mt-3">
						<button-component :busy="form.busy" :label="'Change Password'" :label-loading="'Please wait...'" :button-class="'btn btn-default float-right mt-3 shadow-sm'"></button-component>
					</div>
				</form>
			</div>
        </div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				form: new Form({
					current_password: null,
					password: null,
					password_confirmation: null
				})
			};
		},
		methods: {
			changePassword() {
				this.form.post("/api/user/change-password").then(({ data }) => {
					this.form.reset();
				});
			}
		}
	};
</script>
